<!-- @format -->

<template>
	<pc-drag-list
		v-model="value"
		:detail-form-list="detailFormList"
		title="功能按钮"
		:add-list="addList"
		:components-list="componentsList"
	/>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import ScriptArea from './script-area.vue';
	import PcDragList from '@/components/pc-drag-list/index.vue';

	interface Props {
		modelValue: any;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue || [];
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const componentsList = {
		script: markRaw(ScriptArea),
	};

	const detailFormList = [
		{
			label: '按钮名称',
			code: 'label',
			type: 'input',
		},
		{
			label: '按钮编码',
			code: 'code',
			type: 'input',
			disabled: (formData) => formData.code === 'add' || formData.code === 'delete',
		},
		{
			label: '脚本',
			code: 'script',
			type: 'script',
			hidden: (formData) => formData.code === 'add' || formData.code === 'delete',
		},
	];

	const addList = [
		{
			label: '新增',
			code: 'add',
			script: '',
		},
		{
			label: '删除',
			code: 'delete',
			script: '',
		},
		{
			label: '自定义',
			code: '',
			icon: '',
			script: '',
		},
	];
</script>

<style scoped></style>
